import PesquisaService from '@/service/PesquisaService'

export default {
  namespaced: true,
  state: {
    dados: null,
  },
  getters: {
    dados(state) {
      return state.dados
    },
  },
  mutations: {
    SET_DADOS(state, dados) {
      state.dados = dados
    },
  },
  actions: {
    async findDados({ commit }, obj) {
      commit('SET_DADOS', null)
      const dados = await PesquisaService.curvaAbc(obj)
      commit('SET_DADOS', dados)
      return dados
    },
  },
}
